module.exports = ".ssf-popover {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center; }\n\n.ssf-popover__button {\n  margin: 0 0.5rem; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/shared/components/confirm-dialog/confirm-dialog.component.scss
// module id = 618
// module chunks = 3